import React from "react";

export default function PatientProfileHeader({
  subjectLabel,
  clinicStudySummary,
  measurementCount = 0,
  questionnaireCount = 0,
  canViewAdherence = false,
  onOpenAdherence,
  canViewDemographics = false,
  onOpenDemographics,
  t,
}) {
  const metricCards = [
    {
      label: t("profilePage.measurementsCount", "Measurements"),
      value: measurementCount,
    },
    {
      label: t("profilePage.questionnairesCount", "Questionnaires"),
      value: questionnaireCount,
    },
  ];

  return (
    <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
      <div className="flex flex-col items-start justify-start gap-1">
        <h2 className="text-xl font-semibold text-typography">
          {t("profilePage.subjectPrefix")} {subjectLabel}
        </h2>
        <p className="text-sm text-greyscale-3">{clinicStudySummary}</p>
      </div>

      <div className="flex flex-wrap items-stretch justify-end gap-2">
        <div className="grid grid-cols-2 gap-2">
          {metricCards.map((card) => (
            <div key={card.label} className="card px-3 py-1 text-center">
              <p className="text-xl font-semibold text-typography">{card.value}</p>
              <p className="text-sm text-greyscale-3">{card.label}</p>
            </div>
          ))}
        </div>

        {canViewAdherence ? (
          <button
            type="button"
            className="outlined-button !min-h-0 !px-4 !py-2 !text-sm"
            onClick={onOpenAdherence}
          >
            <span className="material-symbols-outlined text-lg leading-none">
              checklist
            </span>
            {t("profilePage.protocolAdherenceButton", "Adherence")}
          </button>
        ) : null}

        {canViewDemographics ? (
          <button
            type="button"
            className="outlined-button !min-h-0 !px-4 !py-2 !text-sm"
            onClick={onOpenDemographics}
          >
            <span className="material-symbols-outlined text-lg leading-none">
              badge
            </span>
            {t("profilePage.demographicsButton", "Profile")}
          </button>
        ) : null}
      </div>
    </div>
  );
}
